import React, { useState } from "react";
import "./faqDms.css";

import { FiPlus, FiMinus, FiArrowRight } from "react-icons/fi";
import DmsBookingModal from "./dmsBookingModal";

const faqs = [
  {
    question: "What is DMS software?",
    answer:
      "A Distribution Management System helps manufacturers and distribution-driven businesses manage distributors, dealers, orders, inventory, secondary sales, billing, schemes, claims and channel operations.",
  },
  {
    question: "What are the benefits of a DMS?",
    answer:
      "A DMS provides better distributor visibility, inventory control, order management, secondary sales tracking, scheme management, claims management, reporting and business analytics.",
  },
  {
    question: "Is Techcognics DMS suitable for FMCG businesses?",
    answer:
      "Yes. Techcognics DMS can support FMCG and consumer product businesses managing distributors, stockists, dealers, retailers and field sales teams.",
  },
  {
    question: "Can Techcognics DMS manage secondary sales?",
    answer:
      "Yes. The platform can capture and analyze secondary sales by distributor, territory, product, SKU, customer and sales period.",
  },
  {
    question: "Can DMS integrate with our ERP?",
    answer:
      "Yes. Techcognics DMS can integrate with ERP, CRM, accounting, inventory, warehouse and other business applications through APIs and integration workflows.",
  },
  {
    question: "Can DMS manage schemes and claims?",
    answer:
      "Yes. Scheme configuration, promotional programs, claims, approvals and settlement workflows can be digitized and monitored.",
  },
];

const FaqDms = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showDmsModal, setShowDmsModal] = useState(false);

  const toggleFaq = (index) => {
    setActiveIndex((current) => (current === index ? -1 : index));
  };

  const handleDemo = () => {
    const enquiryButton = document.querySelector("#enquiry-button");

    if (enquiryButton) {
      enquiryButton.click();
    }
  };

  return (
    <>
    <section className="faq-dms-section">
      <div className="container">
        <div className="faq-dms-heading">
          <span className="faq-dms-label">FAQ</span>

          <h2>
            Frequently Asked
            <strong> Questions</strong>
          </h2>

          <p>Quick answers about Techcognics DMS.</p>
        </div>
        <div className="faq-dms-grid">
          {faqs.map((faq, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                className={`faq-dms-item ${isActive ? "active" : ""}`}
                key={faq.question}
              >
                <button
                  type="button"
                  className="faq-dms-question"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={isActive}
                  aria-controls={`faq-answer-${index}`}
                >
                  <span>{faq.question}</span>

                  <i aria-hidden="true">
                    {isActive ? <FiMinus /> : <FiPlus />}
                  </i>
                </button>

                <div
                  id={`faq-answer-${index}`}
                  className="faq-dms-answer"
                  aria-hidden={!isActive}
                >
                  <div className="faq-dms-answer-inner">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="faq-dms-cta">
          <div className="faq-dms-cta-content">
            <h3>Ready to see Techcognics DMS?</h3>

            <p>Talk to our team and explore the platform.</p>
          </div>
          <button
            type="button"
            className="faq-dms-cta-button"
            onClick={() => setShowDmsModal(true)}
          >
            Book a Free Demo
            <FiArrowRight />
          </button>
        </div>
      </div>
    </section>
    <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default FaqDms;
